import $ from "jquery";
import Swiper from "swiper";
import Bowser from "bowser";

const CarouselPolos = () => {
  const browser = Bowser.getParser(window.navigator.userAgent);
  var swiper1 = new Swiper(".swiper__polos", {
    effect: "coverflow",
    grabCursor: true,
    centeredSlides: true,
    slidesPerView: 2,
    spaceBetween: 28,
    loop: true,
    direction: "horizontal",
    autoHeight: true,
    updateOnWindowResize: true,
    setWrapperSize: true,
    coverflowEffect: {
      rotate: 0,
      stretch: 0,
      depth: 100,
      modifier: 0,
      slideShadows: false,
    },
    breakpoints: {},
    on: {
      // Hide the previous arrow as initial state
      init: function () {
        $(".swiper-button-prev").hide();
      },
      slideChange: function (slider) {
        $(".polos__intro").each((i, el) => {
          $(el).hide();
          if (slider.realIndex == i) $(el).show();
        });
        $(".polos__intro--tablet").each((i, el) => {
          $(el).hide();
          if (slider.realIndex == i) $(el).show();
        });
        // Hide previous arrow when slide item is NOT the first item
        if (browser.getPlatformType() === "desktop") {
          if (slider.realIndex >= 1) $(".swiper-button-prev").show();
          else $(".swiper-button-prev").hide();
        }
      },
    },
  });

  /** ARROW NAVIGATION */

  // Next slide
  $(".swiper-button-next").on("click", () => {
    swiper1.slideNext();
  });

  // Prev slide
  $(".swiper-button-prev").on("click", () => {
    swiper1.slidePrev();
  });
};

export default CarouselPolos;
